export interface Login {
    email: string
    password: string
}

export interface SignUp extends Login {
    firstName: string
    lastName: string
}

export interface SignUpWithSubscription extends SignUp {
    subscribe: boolean
}

export type Subscription = Omit<SignUpWithSubscription, 'password'>

export type ForgotPassword = {
    email: string
}

export interface ResetPasswordWithOtp {
    otp: string
    password: string
    confirmPassword: string
}
export type ResetPasswordWithOtpPayload = Pick<Login, 'email'> &
    Pick<ResetPasswordWithOtp, 'otp' | 'password'>

export type AuthToken = string

export enum AuthView {
    Login = 'login',
    SignUp = 'signup',
    ForgotPassword = 'forgot-password',
    ResetPasswordWithOtp = 'reset-password-with-otp',
}
export type AuthFormField = {
    name: string
    label: string
    type: 'text' | 'email' | 'password' | 'select' | 'checkbox' | 'otp'
    placeholder?: string
    otp?: {
        length: number
        placeholder: string
    }
    required?: boolean
    description?: string
    ui?: {
        [key: string]: string
    }
    class?: string
}
